import { render, staticRenderFns } from "./GoodsCateMemberDiscountForm.vue?vue&type=template&id=5e50b4ab&scoped=true&"
import script from "./GoodsCateMemberDiscountForm.vue?vue&type=script&lang=js&"
export * from "./GoodsCateMemberDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e50b4ab",
  null
  
)

export default component.exports